module.exports = __webpack_public_path__ + "img/main_pc.2ec26af5.svg";